module.exports = __webpack_public_path__ + "media/echope_alert.297f63b5.mp3";